<template>
  <div class="text-center">
    <transition
      v-if="!done"
      appear
      enter-active-class="animated pulse"
      leave-active-class="animated bounceOut"
      :duration="500"
    >
      <div>
        <template v-if="spinnerType === 'puff'">
          <q-spinner-puff
            class="inline"
            style="animation-duration: 1000ms !important"
            size="90px"
          />
        </template>

        <template v-if="spinnerType === 'ios'">
          <q-spinner-ios
            class="inline"
            style="animation-duration: 1000ms !important"
            size="90px"
            speed="0.1"
          />
        </template>
      </div>
    </transition>

    <transition-group
      v-else
      appear
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
      :duration="1000"
    >
      <q-avatar
        key="after-loading-animation-success"
        class="bg-positive"
        :class="{
          'hidden': error,
        }"
        style="animation-duration: 1000ms !important"
        size="90px"
      >
        <q-icon
          name="fa fa-check"
          color="white"
          size="xl"
        />
      </q-avatar>

      <q-avatar
        key="after-loading-animation-error"
        class="bg-negative"
        :class="{
          'hidden': !error,
        }"
        style="animation-duration: 1000ms !important"
        size="90px"
      >
        <q-icon
          name="fa fa-exclamation"
          color="white"
          size="xl"
        />
      </q-avatar>
    </transition-group>

    <template 
      v-if="!done"
    >
      <slot name="loading">
        <p
          class="text-bold q-my-lg"
          style="font-size: 16px"
        >
          {{ loadingMsg }}
        </p>

        <p class="text-caption">
          {{ i18n.please_wait }}
        </p>
      </slot>
    </template>

    <template v-else>
      <template v-if="!error">
        <slot name="success">
          <div class="text-center">
            <p
              class="text-bold q-mt-lg"
              style="font-size: 16px"
            >
              {{ error ? errorMsg : successMsg }}
            </p>
          </div>
        </slot>
      </template>
      <template v-else>
        <slot name="error">
          <div class="text-center">
            <span class="text-body2 text-center text-negative">{{ i18n.error_occured }}</span>
          </div>
        </slot>
      </template>
    </template>
  </div>
</template>

<script>
import frQuasar from "quasar/lang/fr";
import enQuasar from "quasar/lang/en-US";

export default {
  components: {
  },
  props: {
    done: {
      type: Boolean,
      default: false,
    },
    loadingMsg: {
      type: String,
      default: "Chargement en cours...",
    },
    successMsg: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMsg: {
      type: String,
      default: "",
    },
    spinnerType: {
      type: String,
      default: "puff",
    },
  },
  data() {
    return {
      i18n: {},
    };
  },
  computed: {
  },
  watch: {
  },
  beforeUpdate() {
    this.use_locale(this.$q.lang.isoName);
  },
  beforeMount() {
    this.use_locale(this.$q.lang.isoName);
  },
  methods: {
    use_locale(locale) {
      switch (locale) {
      case enQuasar.isoName:
        this.i18n.please_wait = "Please wait...";
        this.i18n.error_occured = "An error has occurred.";
        break;
      case frQuasar.isoName:
      default:
        this.i18n.please_wait = "Veuillez patienter...";
        this.i18n.upload_in_progress = "Une erreur est survenue.";
        break;
      }
    }
  },
};
</script>
